const Router = (state = [],action) => {

  let rtn




  switch (action.type) {

      case 'ROUTE_CHANGE' :


        rtn = {
            ...state,
            location : { data : action.payload}
          }

      return rtn





   default :
     return state

 }

}




export default Router



// WEBPACK FOOTER //
// ./src/reducers/Router.js